import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import * as Sentry from "@sentry/angular";
import { environment } from './environments/environment';

if (environment.sentryActive) {
  Sentry.init({
    dsn: "https://9b6978a1ea07fa389f6597fff9d5a4eb@o4510726343950336.ingest.de.sentry.io/4510726346440784",
    sendDefaultPii: true
  });

  Sentry.setTag('app_environment', environment.name);

  Sentry.metrics.count('button_click', 1);
  Sentry.metrics.gauge('page_load_time', 150);
  Sentry.metrics.distribution('response_time', 200);
}

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
